<template>
  <div>
    <normal-excel-upload-template
      ref="normalExcelUploadTemplate"
      style="min-height: 625px;"
      :board="board"
      :header="header"
      :downloadLink="downloadLink"
      tableTitle='관리감독자 평가 현황'
      :tableHeader="tableHeader"
      :tableDataType="tableDataType"
      :readExcelData="readExcelData"
      :useFieldCell="false"
      :readonly="board.readonly"
      v-model="form.excelData"
    >
      <template v-slot:title>
        <div class="grid sm:flex items-center gap-2 ">
          <div class="flex items-center">
            <i class="dot"></i>
            <span class="inline-flex items-center gap-3">
              관리감독자 평가 현황
            </span>
          </div>
          <span
            class="inline-flex gap-1 items-center cursor-pointer"
            style="font-size: 14px; color:#7E72F2"
            @click="showPopup = true"
          >
            <feather-icon icon="AlertCircleIcon" style="width: 16px;"/> 관리감독자 업무수행 평가 개별평가 기준
          </span>
        </div>
      </template>

      <template v-slot:header>
        <!-- 기본정보 -->
        <field-select-module
          v-model="form.stdInfo"
          :board="board"
        />
        <div v-if="!board.readonly" class="writeGridContainer">
          <div class="writeGridLineItem">
            <div>파일 업로드</div>
            <div class="flex flex-wrap gap-x-4 gap-y-2">
              <vs-button color="secondary" class="w-full sm:w-auto" type="border" :href="downloadLink">엑셀 템플릿 다운로드</vs-button>
              <vs-button color="secondary" class="w-full sm:w-auto" @click="onClickExcelUpload"> 작성 엑셀 업로드 </vs-button>
            </div>
          </div>
        </div>
      </template>

      <template v-slot:edit="{index, data, rowIndex, rowData, dataType, funcSetEditExcelData}">
        <fragment v-if="dataType === 'no' || dataType === 'total'">{{data}}</fragment>
        <fragment v-else-if="dataType === 'date'">
          <date-selector class="w-full text-left"
                         :value="data"
                         @input="(date) => onSelectDate(date, index, rowData, {index, data, funcSetEditExcelData})"/>
        </fragment>
        <fragment v-else-if="dataType === 'number'">
          <number-input class="w-full"
                        :value="data"
                        :max="maxPoint[index-6]"
                        :min="0"
                        @input="(number) => onChangeNumber(number, index, rowData, {index, data, funcSetEditExcelData})"/>
        </fragment>
        <fragment v-else>
          <ml-input class="w-full"
                    :value="data"
                    @input="(value) => funcSetEditExcelData(index, value, '')"/>
        </fragment>
      </template>
      <template v-slot:column="{index, data, dataType}">
        <p v-if="dataType === 'number'">{{ data || "0"  | comma}}</p>
        <p v-else>{{ data || "-" }}</p>
      </template>

    </normal-excel-upload-template>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />

    <vs-popup id="msiePopup" title="관리감독자 업무수행 평가 개별평가 기준" :active.sync="showPopup" width="1200px">
      <img :src="require('./참고자료.svg')">
    </vs-popup>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import NormalExcelUploadTemplate from "@/views/excel-upload/template/NormalExcelUploadTemplate.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import config from "/public/config";

export default {
  components: {
    DateSelector,
    NumberInput,
    NormalExcelUploadTemplate,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
  },
  data() {
    return {
      maxPoint: [30, 20, 20, 20, 10],
      downloadLink: `${config.BASE_API_URL}/storage/app/media/%EB%8F%99%EA%B5%AD%EC%A0%9C%EA%B0%95_%EA%B4%80%EB%A6%AC%EA%B0%90%EB%8F%85%EC%9E%90_%EC%97%85%EB%AC%B4%EC%88%98%ED%96%89%ED%8F%89%EA%B0%80_%EC%97%91%EC%85%80%EC%97%85%EB%A1%9C%EB%93%9C.xlsx`,
      tableHeader: ['No.', '피평가자<br>부서', '사번', '직위', '이름', '평가자', '기계기구<br>(30)', '보호구<br>(20)', '산재보고<br>(20)', '정리정돈<br>(20)', '지도협조<br>(10)', '총점<br>(100)'],
      tableDataType: ['no', 'string', 'string', 'string', 'string', 'string', 'number', 'number', 'number', 'number', 'number', 'total'],
      form: {
        stdInfo: {},
        excelData: {},
        fileList: [],
      },
      showPopup: false,
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    readExcelData(rowNumber, cells, dataTypes, func) {
      if (rowNumber > 2) {
        const error = [];

        cells.forEach((cell, index) => {
          if (dataTypes[index] === "no") {
            cells[index] = func.rowIndex;
          }
        });

        func.save(cells, error);
      }
    },
    getTotal(data) {
      let total = 0;
      for (let i=6; i<data.length-1; i++) {
        total += data[i];
      }
      return total;
    },
    onClickExcelUpload() {
      this.$refs.normalExcelUploadTemplate.excelUpload();
    },
    onSelectDate(date, index, edit) {
      if (date) {
        const data = new Date(date).format("yyyy-MM-dd");
        const errorMSG = !isNaN(Date.parse(date)) ? "" : "날짜 형식이 아닙니다.";
        edit.funcSetEditExcelData(edit.index, data, errorMSG)
      }
    },
    onChangeNumber(number, index, rowData, edit) {
      const totalIndex = 11;
      if (index > 5 && index < totalIndex) {
        // 총점 계산
        let total = 0;
        let totalErrorMsg = '';
        for (let i=6; i<totalIndex; i++) {
          if (index === i) {
            total += Number(`${number}`);
          } else {
            total += Number(`${rowData[i]}`);
          }
        }
        edit.funcSetEditExcelData(edit.index, number, '');
        edit.funcSetEditExcelData(totalIndex, total, totalErrorMsg);
      }
    },
  }
};
</script>
<style lang="scss" scoped>
</style>

<style lang="scss">
#msiePopup {
  .vs-popup {
    width: calc(1024px + 2.35rem) !important;
  }
}
</style>
